import { useQuery } from '@tanstack/react-query';

import { getServiceServiceTypes } from 'queries';
import { parseErrors, Toast } from 'helpers';
import { JsonDataItem } from 'types';

export const useServiceTypes = (customerId?: number) => {
  const { isInitialLoading: isServiceTypesLoading, data: serviceTypes } = useQuery(
    ['service-types', customerId],
    getServiceServiceTypes,
    {
      onError: (error: JsonDataItem) => {
        Toast.show({ description: parseErrors(error).join(', '), type: Toast.Type.Error });
      },
    },
  );

  return {
    serviceTypes,
    isServiceTypesLoading,
  };
};
